import { render, staticRenderFns } from "./AbnormalTable.vue?vue&type=template&id=91cdbb0c&scoped=true"
import script from "./AbnormalTable.vue?vue&type=script&lang=js"
export * from "./AbnormalTable.vue?vue&type=script&lang=js"
import style0 from "./AbnormalTable.vue?vue&type=style&index=0&id=91cdbb0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91cdbb0c",
  null
  
)

export default component.exports